import type { IntlShape } from "react-intl";
import { match } from "ts-pattern";
import { ProductionUnit } from "../..";

export function getProductionUnit(intl: IntlShape, unit?: ProductionUnit | string) {
	return match(unit)
		.with(ProductionUnit.CompletePanel, () =>
			intl.formatMessage({ defaultMessage: "Gezaagde hele plaat", id: "sGLNyD" }),
		)
		.with(ProductionUnit.CompleteBeam, () =>
			intl.formatMessage({ defaultMessage: "Gezaagde hele balk", id: "hI5SDa" }),
		)
		.with(ProductionUnit.M1, () =>
			intl.formatMessage({ defaultMessage: "Strekkende meter", id: "9oStNa" }),
		)
		.otherwise(() => intl.formatMessage({ defaultMessage: "Vierkante meter", id: "SAHEmB" }));
}
